var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-layout',{staticStyle:{"font-family":"'Font-principal'"},attrs:{"view":"hhr lpR ffr"}},[_c('TheNavbar'),_c('q-page-container',{staticClass:"app-bg"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }